import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/auth";
import cartReducer from "../slices/cart";
import wishlistReducer from "../slices/wishlist";
import filterReducer from "../slices/filter";
import trackingMiddleware from "../tracking/TrackingMiddleware";
import giftTiers from "../slices/giftTiers";
import bundles from "../slices/bundles";
import productGifts from "../slices/productGifts";
import {productGiftsMiddleware} from "../slices/productGifts/productGiftsMiddleware";
import bundleMiddleware from "../slices/bundles/bundleMiddleware";
import {fetchBundles} from "../slices/bundles/utils";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    filter: filterReducer,
    giftTiers: giftTiers,
    productGifts: productGifts,
    bundles: bundles,
  },
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['bundles/fetchBundles/fulfilled'],
          ignoredPaths: [
            'bundles.availableBundles',
            'cart.items',
            'cart.bundles',
            'cart.autoBundles',
          ],
        },
      }).concat(trackingMiddleware)
          .concat(bundleMiddleware)
          .prepend(productGiftsMiddleware.middleware),
});
export function initializeBundleData() {
  const { dispatch } = store;
  dispatch(fetchBundles);
}

